module.exports = __webpack_public_path__ + "img/低通5.47be9dbb.png";